// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"NotFound_notFoundContainer__gnG-2","content":"NotFound_content__ZuKnc","errorCode":"NotFound_errorCode__svC7H","homeButton":"NotFound_homeButton__kNZFI"};